import React from 'react';
import classNames from 'classnames/bind';
import styles from './NotFound.module.css'

const cx = classNames.bind(styles)
const NotFound = () => {
    return (
        <div className={cx("container")}>
            <h1 className={cx("code")}>404</h1>
            <p className={cx("title")}>Đường dẫn không tồn tại</p>
        </div>
    );
};

export default NotFound;